import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GuestIdentificationSessionByGuestKeyQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  guestKey: Types.Scalars['String'];
}>;

export type GuestIdentificationSessionByGuestKeyQuery = { __typename?: 'Query'; getRecipientSessionByGuestKey?: string | null };

export type SendGuestIdentificationEmailMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  email: Types.Scalars['String'];
}>;

export type SendGuestIdentificationEmailMutation = {
  __typename?: 'Mutation';
  sendGuestIdentificationEmail: { __typename?: 'SendGuestIdentificationEmailResponse'; success: boolean };
};

export type VerifyGuestEmailCodeMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  email: Types.Scalars['String'];
  code: Types.Scalars['String'];
}>;

export type VerifyGuestEmailCodeMutation = {
  __typename?: 'Mutation';
  verifyGuestEmailCode: { __typename?: 'VerifyGuestEmailCodeResponse'; success: boolean; guestKey?: string | null; firstName?: string | null; lastName?: string | null };
};

export const GuestIdentificationSessionByGuestKeyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GuestIdentificationSessionByGuestKey' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestKey' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRecipientSessionByGuestKey' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'guestKey' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'guestKey' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGuestIdentificationSessionByGuestKeyQuery__
 *
 * To run a query within a React component, call `useGuestIdentificationSessionByGuestKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestIdentificationSessionByGuestKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestIdentificationSessionByGuestKeyQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestKey: // value for 'guestKey'
 *   },
 * });
 */
export function useGuestIdentificationSessionByGuestKeyQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GuestIdentificationSessionByGuestKeyQuery, GuestIdentificationSessionByGuestKeyQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GuestIdentificationSessionByGuestKeyQuery, GuestIdentificationSessionByGuestKeyQueryVariables>(
    GuestIdentificationSessionByGuestKeyDocument,
    baseOptions,
  );
}
export function useGuestIdentificationSessionByGuestKeyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestIdentificationSessionByGuestKeyQuery, GuestIdentificationSessionByGuestKeyQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GuestIdentificationSessionByGuestKeyQuery, GuestIdentificationSessionByGuestKeyQueryVariables>(
    GuestIdentificationSessionByGuestKeyDocument,
    baseOptions,
  );
}
export type GuestIdentificationSessionByGuestKeyQueryHookResult = ReturnType<typeof useGuestIdentificationSessionByGuestKeyQuery>;
export type GuestIdentificationSessionByGuestKeyLazyQueryHookResult = ReturnType<typeof useGuestIdentificationSessionByGuestKeyLazyQuery>;
export type GuestIdentificationSessionByGuestKeyQueryResult = Apollo.QueryResult<GuestIdentificationSessionByGuestKeyQuery, GuestIdentificationSessionByGuestKeyQueryVariables>;
export const SendGuestIdentificationEmailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendGuestIdentificationEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendGuestIdentificationEmail' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'email' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendGuestIdentificationEmailMutationFn = Apollo.MutationFunction<SendGuestIdentificationEmailMutation, SendGuestIdentificationEmailMutationVariables>;

/**
 * __useSendGuestIdentificationEmailMutation__
 *
 * To run a mutation, you first call `useSendGuestIdentificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGuestIdentificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGuestIdentificationEmailMutation, { data, loading, error }] = useSendGuestIdentificationEmailMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendGuestIdentificationEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SendGuestIdentificationEmailMutation, SendGuestIdentificationEmailMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SendGuestIdentificationEmailMutation, SendGuestIdentificationEmailMutationVariables>(SendGuestIdentificationEmailDocument, baseOptions);
}
export type SendGuestIdentificationEmailMutationHookResult = ReturnType<typeof useSendGuestIdentificationEmailMutation>;
export type SendGuestIdentificationEmailMutationResult = Apollo.MutationResult<SendGuestIdentificationEmailMutation>;
export type SendGuestIdentificationEmailMutationOptions = Apollo.BaseMutationOptions<SendGuestIdentificationEmailMutation, SendGuestIdentificationEmailMutationVariables>;
export const VerifyGuestEmailCodeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VerifyGuestEmailCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyGuestEmailCode' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'email' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'code' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type VerifyGuestEmailCodeMutationFn = Apollo.MutationFunction<VerifyGuestEmailCodeMutation, VerifyGuestEmailCodeMutationVariables>;

/**
 * __useVerifyGuestEmailCodeMutation__
 *
 * To run a mutation, you first call `useVerifyGuestEmailCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyGuestEmailCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyGuestEmailCodeMutation, { data, loading, error }] = useVerifyGuestEmailCodeMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyGuestEmailCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyGuestEmailCodeMutation, VerifyGuestEmailCodeMutationVariables>) {
  return ApolloReactHooks.useMutation<VerifyGuestEmailCodeMutation, VerifyGuestEmailCodeMutationVariables>(VerifyGuestEmailCodeDocument, baseOptions);
}
export type VerifyGuestEmailCodeMutationHookResult = ReturnType<typeof useVerifyGuestEmailCodeMutation>;
export type VerifyGuestEmailCodeMutationResult = Apollo.MutationResult<VerifyGuestEmailCodeMutation>;
export type VerifyGuestEmailCodeMutationOptions = Apollo.BaseMutationOptions<VerifyGuestEmailCodeMutation, VerifyGuestEmailCodeMutationVariables>;
